import { SearchTerm } from "./SearchTerm";

const EnrolmentRelationshipSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "asset.mstDisplayname",
        translationKey: "name"
    },
    {
        heading: "Unique Idenifier",
        accessor: "uniqueIdenifier",
        searchOnName: "asset.mstIdnumber",
        translationKey: "uniqueIdentifier"
    }
];

export default EnrolmentRelationshipSearch;
